$(document).ready(function(){
      var price = $("div#without-capacitor").attr("vprice");
    $(".money-popup").text(price)
//  	$(".steps").hide();
  	$(".main-container").hide();
  	$(".steps[data-step='1']").parents(".main-container").show();
//    $(".steps[data-step='1']").show();
    
    $(".next-btn").on("click",function(e){
     e.preventDefault();
     var selected = $(this).parents(".action-btn").siblings(".custom-options").find("[type='radio']:checked").length;
     if(selected != 0)
     {
       var target = $(this).attr("data-next");
       $(this).parents(".main-container").hide();
       $(".breadcrumb-items.active").addClass("complete").removeClass("active");
       $(".breadcrumb-items[data-item='"+target+"']").addClass("active");
       $(".steps[data-step='"+target+"']").parents(".main-container").show();
     //  $("html, body").animate({ scrollTop: 0 });
       var arrval = [];
       $(this).parents(".main-container").find(".custom-option").each(function(){
         if ($(this).find("input").is(":checked"))
         {
		var find = $(this).find("input:checked").val();

        if(find == '3/8"')
        {
          $(".shopify-section.wraps--main").find("input[value='8-wrap']").parents(".custom-option").nextAll(".custom-option").hide();
        }
        else
        {
          $(".shopify-section.wraps--main").find("input[value='8-wrap']").parents(".custom-option").nextAll(".custom-option").show();
        }

           
         console.log(find)
         arrval.push(find)
         console.log(arrval)
          var heading = $(this).parents(".main-container").find(".heading").text();
         
         heading = heading.replace(/ /g,'');
           console.log(heading)
           var strin = heading.includes("Washer");
           console.log(strin);
           if ( strin == true )
           {
             heading = "Washers, Washer Shape, Washer Color";
         }
           else
           {
           heading = heading;
           }
         var step = $(this).parents(".main-container .steps.container").attr("data-step");
           console.log(step)
         $("tr[data-step='"+step+"']").html("<td style='color: #2d2d2d;padding: 8px;font-weight: 500;width:50%;'>"+heading+"</td><td style='padding: 8px;width:50%;'>"+arrval+"</td>");
         }
        
       })
         
        $('html, body').animate({
            scrollTop: $(".steps[data-step='"+target+"']").parents(".right-side").offset().top - 300
        },"fast");
       return false;
     }
     else
     {
       alert("Please select an option...");
     }
    });
  
  	$(".prev-btn").on("click",function(e){
       e.preventDefault();
       $(this).parents(".action-btn").siblings(".custom-options").find("[type='radio']:checked").prop("checked",false);
       
//       $("html, body").animate({ scrollTop: 0 });
  		
      
       var target = $(this).attr("data-prev");
 
       
       $(".breadcrumb-items.active").removeClass("complete").removeClass("active");
       $(".breadcrumb-items[data-item='"+target+"']").removeClass("complete").addClass("active");
       $(this).parents(".main-container").hide();
       $(".steps[data-step='"+target+"']").parents(".main-container").show(); 
       

       $('html, body').animate({
             scrollTop: $(".steps[data-step='"+target+"']").parents(".right-side").offset().top - 300
       },"fast");

      return false;
       
    });
    
    $(".add-btn").on("click",function(e){
      e.preventDefault();
      var selected = $(this).parents(".action-btn").siblings(".custom-options").find("[type='radio']:checked").length;
//       if(selected != 0)
//       {
        $(this).addClass("disabled");
      var getcapacitor = $(".shopify-section.capacitor--main .custom-options").find("input:checked").val();
      console.log(getcapacitor)
        var customer_tag = $(".item-products").attr("data-customer-tag");
  //      console.log(customer_tag);
        var id = '';
        var qty = $(".quantity-custom").val();
        var properties ='';
        $(".steps").find("input[type='radio']:checked").each(function(index){ 
         var name = $(this).attr("name").replace("select-",'').replace("-",' '); 
         var val = $(this).val();
           properties += "&properties["+name+"]="+val;    
        });

  //      console.log(properties);

        var p_length = $(".item-products").find(".products").length;

        if(p_length != 0)
        {

          if(customer_tag != '')
          {
            if ( getcapacitor != "None" )
            {
              if($("#capacitor-upgrade").is(":checked"))
              {
                id = $(".products[data-tag='"+customer_tag+"']").find("#upgraded-capacitor").attr("idval");
              }
              else
              {
                id = $(".products[data-tag='"+customer_tag+"']").find("#with-capacitor").attr("idval");id = $(".products[data-tag='"+customer_tag+"']").find("#with-capacitor").attr("idval");
              }
              
            }
            else if ( getcapacitor == "None" )
            {
              id = $(".products[data-tag='"+customer_tag+"']").find("#without-capacitor").attr("idval");
            }
            else
            {
              id = $(".products[data-tag='"+customer_tag+"']").attr("data-product");
            }
            if(id != undefined)
            {
               addtocart(id,qty,properties);
            }
            else
            {
              if ( getcapacitor != "None" )
              {
                if($("#capacitor-upgrade").is(":checked"))
                {
                  id = $(".products[data-tag='Normal']").find("#upgraded-capacitor").attr("idval");
                }
                else
                {
                  id = $(".products[data-tag='Normal']").find("#with-capacitor").attr("idval");
                }
                
              }
              else if ( getcapacitor == "None" )
              {
                id = $(".products[data-tag='Normal']").find("#without-capacitor").attr("idval");
              }
              else
              {
                id = $(".products[data-tag='Normal']").attr("data-product");
              }
              if(id != undefined)
              {
                  addtocart(id,qty,properties);
              }
            }
          }
          else
          {
            if ( getcapacitor != "None" )
            {
              if($("#capacitor-upgrade").is(":checked"))
              {
                id = $(".products[data-tag='Normal']").find("#upgraded-capacitor").attr("idval");
              }
              else
              {
                id = $(".products[data-tag='Normal']").find("#with-capacitor").attr("idval");
              }
              
            }
            else if ( getcapacitor == "None" )
            {
              id = $(".products[data-tag='Normal']").find("#without-capacitor").attr("idval");
            }
            else
            {
              id = $(".products[data-tag='Normal']").attr("data-product");
            }
            if(id != undefined)
            {
              addtocart(id,qty,properties);
            }
          }
          console.log(id);
        }
//       }
//       else
//       {
//          alert("Please select an option...");
//       }
    });
    
    
    function addtocart(id,qty,prop)
    {
      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        accepts: "application/json",
        dataType: 'json',
        data: "quantity="+qty+"&id="+id+prop,
        success: function(res) {
            console.log('success', res);

//             document.documentElement.dispatchEvent(new CustomEvent('product:added', {
//               bubbles: true,
//               detail: {
//                 quantity: qty
//               }
//             }));
              
//            setTimeout(function(){
//               $(".header__cart-toggle").siblings("#mini-cart").attr("aria-hidden","false");
//               $(".header__cart-toggle").attr("aria-expanded","true");
              
//               var length = $(".mini-cart__line-item").length;
//               $(".header__cart-count").text(length);
//               $(".add-btn").removeClass("disabled");
//            }, 500);  
          window.location.href = "/cart";
        },
        error: function(res) {
            console.log('error', res)
        }
       });
    }
  var getshape = $(".shopify-section.washer--shape-in .custom-options").html();
  var getshapeheading = $(".shopify-section.washer--shape-in .heading").html();
  var getcolor = $(".shopify-section.washer--color-in .custom-options").html();
  var getcolorheading = $(".shopify-section.washer--color-in .heading").html();
  $(".options--shape .custom-options").html(getshape);
  $(".options--shape .heading").html(getshapeheading);
  $(".options--color .custom-options").html(getcolor);
  $(".options--color .heading").html(getcolorheading);
  
  var colordata = $(".shopify-section.washer--color-in .steps.container button.next-btn").attr("data-next");
  $(".washers--main").find(".steps.container button.next-btn").attr("data-next", colordata);
  var prevgo = $(".shopify-section.washer--shape-in .steps.container button.prev-btn").attr("data-prev");
  $(".shopify-section.capacitor--main button.prev-btn").attr("data-prev",prevgo);
  $(".shopify-section.washers--main").find("input").on("change", function(){
    var washer = $(".custom-options.washers-opt-m").find("input:checked").val();
    //console.log(washer);
    var washershape = $(".options--shape .custom-options").find("input:checked").val();
    console.log(washershape);
    if ( washer == "Thick" && washershape == "Round" )
    {
    $(".options--color").find("input").removeAttr("disabled");
    $(".options--color").find("input[value='White']").attr("disabled","disabled");
      $(".options--color").find("input[value='White']").prop('checked', false);
    }
    else if ( washer == "Thick" && washershape == "Square" )
    {
    $(".options--color").find("input").removeAttr("disabled");
    $(".options--color").find("input[value='White']").attr("disabled","disabled");
     $(".options--color").find("input[value='White']").prop('checked', false);
    }
    else if ( washer == "Thin" && washershape == "Round" )
    {
    $(".options--color").find("input").removeAttr("disabled");
    $(".options--color").find("input[value='Red']").attr("disabled","disabled");
    $(".options--color").find("input[value='Brown']").attr("disabled","disabled");
	$(".options--color").find("input[value='Red']").prop('checked', false);
    $(".options--color").find("input[value='Brown']").prop('checked', false);
    }
    else if ( washer == "Thin" && washershape == "Square" )
    {
      $(".options--color").find("input").removeAttr("disabled");
    $(".options--color").find("input[value='Black']").attr("disabled","disabled");
      $(".options--color").find("input[value='Black']").prop('checked', false);
    }
  })
  
  //core height 
  $(".core-height-main").find("input").on("click", function(){
  var getval = $(this).val();
    console.log(getval);
    if ( getval == '1"' )
    {
    $(".wraps--main").find("input[val='b-9-wrap-b-br-not-for-1-coil']").attr("disabled","disabled");
    $(".wraps--main").find("input[val='b-10-wrap-b-br-not-for-1-coil']").attr("disabled","disabled");
      $(".wraps--main").find("input[val='b-9-wrap-b-br-not-for-1-coil']").prop('checked', false);
    $(".wraps--main").find("input[val='b-10-wrap-b-br-not-for-1-coil']").prop('checked', false);
    }
    else
    {
    $(".wraps--main").find("input").removeAttr("disabled");
    }
  });

  //capacitor
  $(".capacitor--main").find(".custom-options input").on("click",function(){
    var capval = $(this).val();
    if(capval == "47uf/35v" || capval == "47uf/50v" || capval == "50uf/50v")
    {
      $(".custom-upgrade").show();
    }
    else
    {
      $(".custom-upgrade").hide();
      $(".custom-upgrade").find("input").prop("checked",false);
    }
  });

  
  $("button.next-btn[data-next='8']").on("click", function(){
  var getCapacitor = $(".shopify-section.capacitor--main .custom-options").find("input:checked").val();
    if ( getCapacitor != "None" )
    {
      if($("#capacitor-upgrade").is(":checked"))
      {
        var  price = $("#upgraded-capacitor").attr("vprice");
        var qty = $("input.quantity-custom").val();
      }
      else
      {
        var  price = $("#with-capacitor").attr("vprice");
        var qty = $("input.quantity-custom").val();
      }
      price  = price.replace("$", "");
      price = parseFloat(price) * (qty);
      price = "$"+price.toFixed(2);
      $(".final-produt-price--add .price").text(price);
      $(".totl--price").text(price);
      $(".totl--price").attr("price", price);
      $(".total-price").removeClass("hide");
      $(".money-popup").text(price);
    }
    else 
    {
      var price = $("#without-capacitor").attr("vprice");
      var qty = $("input.quantity-custom").val();
      price  = price.replace("$", "");
      price = parseFloat(price) * (qty);
      price = "$"+price.toFixed(2);
      $(".final-produt-price--add .price").text(price);
      $(".totl--price").text(price);
      $(".totl--price").attr("price", price);
      $(".total-price").removeClass("hide");
      $(".money-popup").text(price);
    }
  })
  $("button.next-btn.final-step-show").on("click", function(){
    var getCapacitor = $(".shopify-section.capacitor--main .custom-options").find("input:checked").val();
    if ( getCapacitor != "None" )
    {
      if($("#capacitor-upgrade").is(":checked"))
      {
        var  price = $("#upgraded-capacitor").attr("vprice");
        var qty = $("input.quantity-custom").val();
      }
      else
      {
        var  price = $("#with-capacitor").attr("vprice");
        var qty = $("input.quantity-custom").val();
      }
      price  = price.replace("$", "");
      price = parseFloat(price) * (qty);
      price = "$"+price.toFixed(2);
      $(".final-produt-price--add .price").text(price);
      $(".totl--price").text(price);
      $(".totl--price").attr("price", price);
      $(".total-price").removeClass("hide");
      $(".money-popup").text(price);
    }
    else 
    {
       var price = $("#without-capacitor").attr("vprice");
       var qty = $("input.quantity-custom").val();
       price  = price.replace("$", "");
       price = parseFloat(price) * (qty);
       price = "$"+price.toFixed(2);
       $(".final-produt-price--add .price").text(price);
       $(".totl--price").text(price);
       $(".totl--price").attr("price", price);
       $(".total-price").removeClass("hide");
       $(".money-popup").text(price);
    }
    
    $(".shopify-section").each(function(){
      $(this).find(".custom-options").each(function(){
      var get = $(this).find("input:checked").val();
      //console.log(get);
        if ( get != undefined )
        {
          var gethtml = $(this).find("input:checked").parents(".custom-option").html();
          var getId = $(this).parents(".steps.container").attr("data-step");
          //console.log(gethtml);
          $(".step--final-n .custom-options").append('<div class="custom-option" data-step-custom="'+getId+'">'+gethtml+'<span class="edit--selection--ico" data-step-t="'+getId+'" ><img src="https://cdn.shopify.com/s/files/1/0298/0583/8469/files/edit.png?v=1653625257"></span></div>');
          //$(".step--final-n .custom-options").find(".custom-option input").attr("name", "finalall");
        }
      })
      
    })
        var images = [];
    var values = [];
    $(".custom-option[data-step-custom='4']").each(function(){
    values.push($(this).find("input").val())
    images.push($(this).find("label img").attr("src"))
    })
    $(".custom-option[data-step-custom='4']").wrapAll("<div class='custom-option' data-step-custom='4'></div>")
    $(".custom-option[data-step-custom='4']").html('<input type="radio" value="'+values+'" id="ch-opt3-1" name="washers" style="display:none;"><label for="ch-opt3-1"><img src="'+ images[1] +'"><span class="opt-title">' +values+ '</span></label><span class="edit--selection--ico" data-step-t="4"><img src="https://cdn.shopify.com/s/files/1/0298/0583/8469/files/edit.png?v=1653625257"></span>')
    $(".edit--selection--ico").on("click", function(e){
    e.preventDefault();
    e.stopPropagation();
    //console.log("click span");
  	var target = $(this).attr("data-step-t");
       $(this).parents(".main-container").hide();
       $(".breadcrumb-items.active").addClass("complete").removeClass("active");
       $(".breadcrumb-items[data-item='"+target+"']").addClass("active");
       $(".steps[data-step='"+target+"']").parents(".main-container").show();
     //  $("html, body").animate({ scrollTop: 0 });
  		
        $('html, body').animate({
            scrollTop: $(".steps[data-step='"+target+"']").parents(".right-side").offset().top - 300
        },"fast");
      $(".custom-options.final-step-element").empty();
       return false;
      
  })

  })
  
//   function myFunction() {
  $(".edit--selection--ico").on("click", function(e){
    e.preventDefault();
    e.stopPropagation();
    //console.log("click span");
  	var target = $(this).attr("data-step-t");
       $(this).parents(".main-container").hide();
       $(".breadcrumb-items.active").addClass("complete").removeClass("active");
       $(".breadcrumb-items[data-item='"+target+"']").addClass("active");
       $(".steps[data-step='"+target+"']").parents(".main-container").show();
     //  $("html, body").animate({ scrollTop: 0 });
  		
        $('html, body').animate({
            scrollTop: $(".steps[data-step='"+target+"']").parents(".right-side").offset().top - 300
        },"fast");
       return false;
    $(".custom-options.final-step-element").empty();
  })
  $(".final-prev--btn").on("click", function(){
  $(".custom-options.final-step-element").empty();
  })
  
// }
//   myFunction()
//   $(".custom-options.final-step-element .custom-option").on("click",function(){
//   console.log("click");
//   })
  $("button.open-popup").on("click", function(){
  $(".modal-c-b").show();

    $(".hidden-print-in").html($(".modal-c-b").html());
    $(".hidden-print-in .print-btn").remove();
    $(".hidden-print-in span.close-c-b").remove();
    $(".overlay-add").show();
  })
  $(".close-c-b").on("click", function(){
  $(".modal-c-b").hide();
    $(".overlay-add").hide();
  })
  $(".overlay-add").on("click", function(){
   $(".modal-c-b").hide();
    $(".overlay-add").hide();
  })
  
   $("button.plus-btn").on("click", function(e){
     const price = $("span.totl--price").attr("price");
    var vprice = price.replace("$","");
      e.preventDefault();
     e.stopPropagation();
    var getmeta = $(this).siblings("input.quantity-custom").attr("step");
      var ctval = $(this).siblings("input.quantity-custom").val();
      var final = parseInt(getmeta) + parseInt(ctval);
      if ( final >= getmeta )
      {
      $(this).siblings("input.quantity-custom").val(final);
        
      }
     var fprice = parseFloat(vprice) * final;
     fprice = fprice.toFixed(2);   
     $("span.totl--price").text("$"+fprice)
        
    })
    $("button.miuns-btn").on("click", function(e){
      const price = $("span.totl--price").attr("price");
     var vprice = price.replace("$","");
      e.preventDefault();
     e.stopPropagation();
    var getmeta = $(this).siblings("input.quantity-custom").attr("step");
      var ctval = $(this).siblings("input.quantity-custom").val();
      var final =  parseInt(ctval) - parseInt(getmeta);
      if ( final >= getmeta )
      {
      $(this).siblings("input.quantity-custom").val(final);
         var fprice = parseFloat(vprice) * final;
        fprice = fprice.toFixed(2);
        $("span.totl--price").text("$"+fprice)
      }
    })

  
  
  });